<template>
    <li data-mobile-menu-item>
        <!-- <router-link class="main-menu__link" to="/">Home</router-link> -->
        <slot></slot>
    </li>
</template>

<script>
export default {
    props: {
        hassubmenu: {
            type: String,
            required: true
        }
    },
    computed: {
        menuHasSub() {
            return this.hassubmenu === 'Y' ? 'main-menu__item--submenu--menu main-menu__item--has-submenu' : '';
        }
    },
}
</script>